import React, { useState } from "react";
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Stack,
    CircularProgress,
    Snackbar,
    Alert,
} from "@mui/material";

import { createCatalogSubject } from "../../api/subjects";

const AddCatalogSubjectButton = ({ onCreated }) => {
    const [open, setOpen] = useState(false);
    const [title, setTitle] = useState("");
    const [slug, setSlug] = useState("");
    const [loading, setLoading] = useState(false);

    const [snack, setSnack] = useState({
        open: false,
        severity: "success",
        message: "",
    });

    function reset() {
        setTitle("");
        setSlug("");
    }

    async function handleCreate() {
        const t = title.trim();
        const s = slug.trim();

        if (!t) {
            setSnack({
                open: true,
                severity: "error",
                message: "Введіть назву предмета",
            });
            return;
        }

        if (!s) {
            setSnack({
                open: true,
                severity: "error",
                message: "Введіть коротку назву (slug)",
            });
            return;
        }

        setLoading(true);

        try {
            await createCatalogSubject({
                title: t,
                subjectSlug: s,
            });

            setSnack({
                open: true,
                severity: "success",
                message: "Предмет додано в каталог",
            });

            setOpen(false);
            reset();
            onCreated?.(); // щоб можна було перезавантажити список
        } catch (e) {
            const msg =
                e?.response?.data ||
                e?.message ||
                "Не вдалося додати предмет";

            setSnack({
                open: true,
                severity: "error",
                message: String(msg),
            });
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <Button variant="outlined" onClick={() => setOpen(true)}>
                Додати предмет (каталог)
            </Button>

            <Dialog open={open} onClose={() => !loading && setOpen(false)} fullWidth maxWidth="sm">
                <DialogTitle>Новий предмет у каталозі</DialogTitle>

                <DialogContent>
                    <Stack spacing={2} sx={{ mt: 1 }}>
                        <TextField
                            label="Назва"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            fullWidth
                        />

                        <TextField
                            label="Коротка назва (slug)"
                            value={slug}
                            onChange={(e) => setSlug(e.target.value)}
                            fullWidth
                            helperText="Наприклад: bukv, math, geometry"
                        />
                    </Stack>
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setOpen(false)} disabled={loading}>
                        Скасувати
                    </Button>
                    <Button variant="contained" onClick={handleCreate} disabled={loading}>
                        {loading ? <CircularProgress size={18} /> : "Додати"}
                    </Button>
                </DialogActions>
            </Dialog>

            <Snackbar
                open={snack.open}
                autoHideDuration={3500}
                onClose={() => setSnack((s) => ({ ...s, open: false }))}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            >
                <Alert
                    severity={snack.severity}
                    variant="filled"
                    onClose={() => setSnack((s) => ({ ...s, open: false }))}
                >
                    {snack.message}
                </Alert>
            </Snackbar>
        </>
    );
};

export default AddCatalogSubjectButton;
